import React from 'react';
import BottomNav from '../components/BottomNav';

const Vaults = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Private Vaults</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Secure Storage Solutions</p>
        
        <div className="card">
          <p>
            State-of-the-art secure storage facilities for your most valuable possessions. 
            Premium vaults with 24/7 security and climate control.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Maximum Security</h3>
              <p>Biometric access and advanced surveillance systems</p>
            </div>
            <div className="feature-item">
              <h3>Climate Controlled</h3>
              <p>Perfect preservation conditions for valuables</p>
            </div>
            <div className="feature-item">
              <h3>Private Access</h3>
              <p>24/7 availability with complete confidentiality</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default Vaults;
